import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";

// Pages
import HomePage from "@/pages/HomePage";
import AbonnementPage from "@/pages/AbonnementPage";
import InterventionPage from "@/pages/InterventionPage";
import EntretienPage from "@/pages/EntretienPage";
import AmenagementPage from "@/pages/AmenagementPage";
import ElagagePage from "@/pages/ElagagePage";
import ConseilPage from "@/pages/ConseilPage";
import BlogPage from "@/pages/BlogPage";
import BlogDetailPage from "@/pages/BlogDetailPage";
import CreditImpotPage from "@/pages/CreditImpotPage";
import ServicesPage from "@/pages/ServicesPage";
import ContactPage from "@/pages/ContactPage";
import CityPage from "@/pages/CityPage";
import MentionsLegalesPage from "@/pages/MentionsLegalesPage";
import PolitiqueConfidentialitePage from "@/pages/PolitiqueConfidentialitePage";
import CGVPage from "@/pages/CGVPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminServices from "@/pages/admin/AdminServices";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminPages from "@/pages/admin/AdminPages";
import AdminCityPages from "@/pages/admin/AdminCityPages";
import AdminContent from "@/pages/admin/AdminContent";
import AdminSiteContent from "@/pages/admin/AdminSiteContent";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminEmails from "@/pages/admin/AdminEmails";
import AdminSettings from "@/pages/admin/AdminSettingsPage";

// Components
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import FloatingMenu from "@/components/FloatingMenu";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/abonnement" element={<AbonnementPage />} />
            <Route path="/intervention" element={<InterventionPage />} />
            <Route path="/entretien" element={<EntretienPage />} />
            <Route path="/amenagement" element={<AmenagementPage />} />
            <Route path="/elagage" element={<ElagagePage />} />
            <Route path="/conseil" element={<ConseilPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/credit-impot" element={<CreditImpotPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
            <Route path="/cgv" element={<CGVPage />} />
            
            {/* City SEO Pages */}
            <Route path="/:citySlug" element={<CityPage />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/services" element={<ProtectedRoute><AdminServices /></ProtectedRoute>} />
            <Route path="/admin/reviews" element={<ProtectedRoute><AdminReviews /></ProtectedRoute>} />
            <Route path="/admin/blog" element={<ProtectedRoute><AdminBlog /></ProtectedRoute>} />
            <Route path="/admin/pages" element={<ProtectedRoute><AdminPages /></ProtectedRoute>} />
            <Route path="/admin/city-pages" element={<ProtectedRoute><AdminCityPages /></ProtectedRoute>} />
            <Route path="/admin/content" element={<ProtectedRoute><AdminContent /></ProtectedRoute>} />
            <Route path="/admin/site-content" element={<ProtectedRoute><AdminSiteContent /></ProtectedRoute>} />
            <Route path="/admin/quotes" element={<ProtectedRoute><AdminQuotes /></ProtectedRoute>} />
            <Route path="/admin/emails" element={<ProtectedRoute><AdminEmails /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
          </Routes>
          
          <FloatingMenu />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
